import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { startAppInitialization, StoreState } from "../../store/reducers";
import SplashPage from "../splash/SplashPage";

/** Component for wrapping backend config & auth related app settings. */
const AppWrapper = (props: React.PropsWithChildren<{}>) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const appConfig = useSelector((state: StoreState) => state.appConfig);

    // ONE-TIME initialization start -- we can't even finish rendering this component until app init has been done!
    useEffect(() => {
        dispatch(startAppInitialization());
    }, [dispatch]);

    if (!appConfig) {
        return (<SplashPage loadingText={t('splash.initializing')} />);
    }

    const AppWrapperComponent = appConfig.getBackendApi().getAppWrapperComponent();

    return (<AppWrapperComponent>{props.children}</AppWrapperComponent>);
}

export default AppWrapper;
